import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const BoutonOeil = ({ value, onChange, placeholder = "Mot de passe", className = "", ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md transition-colors hover:bg-black/5 dark:hover:bg-white/5"
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="h-4 w-4 text-[#6B6B8A]" /> : <Eye className="h-4 w-4 text-[#6B6B8A]" />}
      </button>
    </div>
  );
};

export default BoutonOeil;
